import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const chartService = {
    getSalesChart,
    getAppointmentChart,
    getRottingDeals,
    getFacebook,
    getGoogleData,
    getSuppliers,
    updateSupplier,
    getSupplierData,
    getOrganicData,
    getAllMarketingData,
    getCallCentreData,
    getDealsByCreatedDate,
    getVoiceAnalyzeScoring,
}

function getDealsByCreatedDate(start, end) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/deals/list/${start}/${end}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCallCentreData(start, end) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/callcenter/stats/${start}/${end}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllMarketingData(start, end, interval) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/marketing-all/${start}/${end}/${interval}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getOrganicData(start, end, interval, who) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/organic/${start}/${end}/${interval}/${who}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSupplierData(start, end, interval, who) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/suppliers/${start}/${end}/${interval}/${who}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function updateSupplier(id, obj) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(obj)
    };

    return fetch(BASE_URL + `/suppliers/${id}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSuppliers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/suppliers/all`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getGoogleData(start, end, interval) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/google/${start}/${end}/${interval}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFacebook(start, end, interval) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/facebook/${start}/${end}/${interval}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSalesChart(start, end) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/sales/${start}/${end}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAppointmentChart(start, end) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/chart/appointment/${start}/${end}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getRottingDeals() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/rotting`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getVoiceAnalyzeScoring(start, end, page) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/reporting/voiceAnalyze/${start}/${end}/${page}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}